<template>
  <div :class="{ fullscreen: fullscreen }" class="tinymce-container">
    <textarea :id="tinymceId" class="tinymce-textarea" />
  </div>
</template>

<script>

import plugins from './plugins';
import toolbar from './toolbar';
// import {uploadImage} from "@/assets/js/util/ZBKJIutil";

export default {
  name: 'Tinymce',
  props: {
    id: {
      type: String,
      default: function () {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
      },
    },
    value: {
      type: String,
      default: '',
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table',
    },
    height: {
      type: Number,
      required: false,
      default: 400,
    },
    moduleName: {
      type: String,
      default: 'default',
    },
    // 只读模式：编辑区不可修改且隐藏工具栏/菜单栏，内容仍可滚动查看。
    // 默认 false，不影响其它调用方。
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: 'en',
        zh: 'zh_CN',
      },
    };
  },
  computed: {
    language() {
      // return this.languageTypeList[this.$product.getters.language]
      return this.languageTypeList['zh'];
    },
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() => window.tinymce.get(this.tinymceId).setContent(val || ''));
      }
    },
    // 只读态切换（同一页面在「查看 / 编辑」之间切换时会用到）
    readonly(val) {
      this.setReadonlyMode(val);
    },
    language() {
      this.destroyTinymce();
      this.$nextTick(() => this.initTinymce());
    },
  },
  mounted() {
    this.initTinymce();
  },
  activated() {
    this.initTinymce();
  },
  deactivated() {
    this.destroyTinymce();
  },
  destroyed() {
    this.destroyTinymce();
  },
  methods: {
    initTinymce() {
      const _this = this;
      if (typeof window.tinymce === 'undefined') {
        console.error('[Tinymce] window.tinymce 未加载，请检查 /static/tinymce4.7.5/tinymce.min.js 是否正确加载');
        return;
      }
      // 如果已有实例，先销毁
      const existingInstance = window.tinymce.get(this.tinymceId);
      if (existingInstance) {
        existingInstance.destroy();
      }
      try {
        window.tinymce.init({
          language: this.language,
          language_url: '/static/tinymce4.7.5/langs/zh_CN.js',
          selector: `#${this.tinymceId}`,
          height: this.height,
          body_class: 'panel-body ',
          object_resizing: false,
          toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
          menubar: this.menubar,
          plugins: plugins,
          end_container_on_empty_block: true,
          powerpaste_word_import: 'clean',
          code_dialog_height: 450,
          code_dialog_width: 1000,
          advlist_bullet_styles: 'square',
          advlist_number_styles: 'default',
          imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
          default_link_target: '_blank',
          link_title: false,
          convert_urls: false, //防止路径被转化为相对路径
          paste_data_images: true, // 默认是false的，记得要改为true才能粘贴
          nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
          init_instance_callback: (editor) => {
            if (_this.value) {
              editor.setContent(_this.value);
            }
            _this.hasInit = true;
            // 初始化完成后应用只读态（activated 会重建实例，所以放在这里而不是 mounted）。
            // 只在需要只读时调用，避免影响未使用该属性的调用方。
            if (_this.readonly) {
              _this.setReadonlyMode(true);
            }
            editor.on('NodeChange Change KeyUp SetContent', () => {
              this.hasChange = true;
              this.$emit('input', editor.getContent());
            });
          },
          setup(editor) {
            editor.addButton('Upload', {
              icon: 'image',
              tooltip: '上传图片',
              onclick: function () {
                _this.modalPicTap(true)
              },
            });
          },
          images_upload_handler: async (blobInfo, success, failure) => {
            try {
              const res = await _this.$api.rPost('/api/school/file/upload/base64image', {
                file: blobInfo.base64(),
                module: _this.moduleName,
              });
              if (res.status === 1) {
                success(res.data.url);
                const base64Src = blobInfo.blobUri();
                const editor = window.tinymce.get(_this.tinymceId);
                if (editor) {
                  const content = editor.getContent();
                  const updatedContent = content.replace(
                    new RegExp(base64Src.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),
                    res.data.url
                  );
                  editor.setContent(updatedContent);
                  _this.$emit('input', updatedContent);
                }
              } else {
                failure(res.message || '图片上传失败');
              }
            } catch (error) {
              console.error('图片上传异常:', error);
              failure('图片上传失败，请重试');
            }
          },
        });
      } catch (error) {
        console.error('[Tinymce] 初始化失败:', error);
      }
    },
    modalPicTap(multiple) {
      const _this = this;
      this.$modalUpload(
        function (img) {
          if (!img) return;
          let arr = [];
          if (img.length > 10) return _this.$message.warning('最多选择10张图片！');
          img.map((item) => {
            arr.push(item.sattDir || item.url);
          });
          _this.imageSuccessCBK(arr);
        },
        multiple,
        'imagesAndVideos',
      );
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId);
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen');
      }

      if (tinymce) {
        tinymce.destroy();
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },
    /**
     * 设置编辑器只读态
     * TinyMCE 4 用 setMode('readonly' | 'design')；若该 API 不可用，
     * 退化为关闭编辑区 contenteditable —— 保证不可编辑，同时内容仍可滚动查看。
     * @param {Boolean} readonly
     */
    setReadonlyMode(readonly) {
      const editor = window.tinymce && window.tinymce.get(this.tinymceId);
      if (!editor) return;
      try {
        if (typeof editor.setMode === 'function') {
          editor.setMode(readonly ? 'readonly' : 'design');
        } else if (editor.getBody()) {
          editor.getBody().setAttribute('contenteditable', readonly ? 'false' : 'true');
        }
      } catch (e) {
        console.error('[Tinymce] 切换只读态失败:', e);
      }
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    },
    imageSuccessCBK(arr) {
      const _this = this;
      arr.forEach((v) => {
        if (this.getFileType(v) == 'video') {
          window.tinymce.get(_this.tinymceId).insertContent(`<video class="wscnph" src="${v}" controls muted></video>`);
        } else {
          window.tinymce.get(_this.tinymceId).insertContent(`<img class="wscnph" src="${v}" style="display: block; vertical-align: top;" />`);
        }
      });
    },
    getFileType(fileName) {
      // 后缀获取
      let suffix = '';
      // 获取类型结果
      let result = '';
      try {
        const flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find((item) => item === suffix);
      if (result) {
        return 'image';
      }
      // 匹配 视频
      const videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find((item) => item === suffix);
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    },
  },
};
</script>

<style scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}
.tinymce-container >>> .mce-fullscreen {
  z-index: 10000;
}
.tinymce-textarea {
  display: none;
}
.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  /*z-index: 2005;*/
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}
.editor-upload-btn {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Tinymce/index.vue